'use strict';

angular.module('amexReconciliationApp')
  .component('accountingCodeModal', {
    templateUrl: 'scripts/views/modals/accounting-code-modal.html',
    bindings: {
      closeModalCallback: '&',
      schema: '<',
      field: '=',
      onFieldValueChanged: '&',
      clearLowerComboValues: '&',
      searchString: '<',
      allocation: '<',
      allocationIndex: '<'
    },
    controller: function (SiteConfigModel,
                          PaginationModelFactory,
                          AccountingCodeValueRepository) {
      var self = this;
      var PAGE_SIZE = 1000;
      var codePaginationModel = PaginationModelFactory.create(PAGE_SIZE);
      var locallySelectedCode = null;

      self.$onInit = function () {
        self.codes = codePaginationModel.recordsOnCurrentPage;
        self.totalCount = codePaginationModel.totalCount;
        self.currentPage = codePaginationModel.pageNumber;
        self.updateCurrentPage = codePaginationModel.updateCurrentPage;
        self.pageSize = codePaginationModel.pageSize;
        self.pageStart = codePaginationModel.pageStart;
        self.pageEnd = codePaginationModel.pageEnd;
        self.showPagination = codePaginationModel.showPagination;
        self.pageSizeInput = codePaginationModel.pageSize();
        self.closeModal = self.closeModalCallback;
        self.searchTerm = '';
        self.numberOfCodes = 0;
        self.loadingCodes = false;
        self.getNumberOfCodes();
        self.getCodes();
      };

      self.displayString = function(value, description) {
        var display = value;
        if (description) {
          display = display + ' (' + description + ')';
        }
        return display;
      };

      self.selectCode = function(value) {
        locallySelectedCode = value;
      };
      
      self.apply = function() {
        if (locallySelectedCode) {
          self.field.value = locallySelectedCode;
          self.onFieldValueChanged();
          self.clearLowerComboValues({index: self.allocationIndex, position: self.field.position});
        }
        self.closeModal();
      };

      self.rowIsSelected = function(code) {
        return _.isEqual(code, locallySelectedCode);
      };

      self.getCodes = function() {
        self.loadingCodes = true;
        var linkedComboStrings = getLinkedComboFieldStrings();
        var params = {companyId: SiteConfigModel.companyId(),
          siteNumber: SiteConfigModel.siteNumber(),
          schema: self.schema,
          searchString: self.searchTerm.toUpperCase(),
          comboPositions: linkedComboStrings.positions,
          comboValues: linkedComboStrings.values
        };

        AccountingCodeValueRepository.getAccountingCodes(params).then(function (codes) {
          codePaginationModel.repaginate(codes);

          var codeExists = !_.some(codes, function(code) {return _.get(code,'value',null) === locallySelectedCode;});
          if(locallySelectedCode && codeExists) { locallySelectedCode = null; }

          self.loadingCodes = false;
        });
      };

      self.getHeaderMessage = function () {
        if(self.numberOfCodes > 5000) {
          return 'allocations.ModalMessage';
        }else{
          return '';
        }
      };

      self.getNumberOfCodes = function () {
        var linkedComboStrings = getLinkedComboFieldStrings();
        var params = {companyId: SiteConfigModel.companyId(),
          siteNumber: SiteConfigModel.siteNumber(),
          schema: self.schema,
          comboPositions: linkedComboStrings.positions,
          comboValues: linkedComboStrings.values
        };
        
        if(self.schema.validationIndicator === 'N') {
          self.numberOfCodes = 0;
        }else{
          AccountingCodeValueRepository.getTotalNumberOfAccountingCodes(params).then(function (totalCount) {
            self.numberOfCodes = totalCount[0];
          });
        }
      };

      function getLinkedComboFieldValues() {
        var schemas = SiteConfigModel.getAccountingFieldSchemas();
        var linkedComboFields = [];
        if (self.schema.validationComboId !== 0) {
          linkedComboFields = _.map(_.filter(schemas, function(o) {
            return (o.validationComboId === self.schema.validationComboId &&
              o.displayIndex < self.schema.displayIndex);
          }), function(filteredSchema) {
            return {
              position: _.get(filteredSchema, 'validationComboPosition', 0),
              value: _.get(_.find(self.allocation.accountingFieldValues, ['position', filteredSchema.position]), 'value', '')
            };
          });
        }
        return linkedComboFields;
      }

      function getLinkedComboFieldStrings() {
        var linkedComboFields = getLinkedComboFieldValues();
        var positions = 'start,';
        var values = 'start,';
        _.forEach(linkedComboFields, function(o) {
          positions += o.position.toString() + ',';
          values += o.value + ',';
        });
        return {positions: positions+'end', values: values+'end'};
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/accountingCodeModal.js
// module id = 425
// module chunks = 0